import { useLocation, useNavigate, useParams } from "react-router";
import OverviewLesson from "../../pages/home/components/dashboard/teacher/lessons/OverviewLesson";
import { useState } from "react";
import "./LessonAndAssignmentTab.css";

/**
 * View-only lesson page: shows only OverviewLesson (no Assignments tab or extra chrome).
 * Used when navigating via "View Lesson" from the course lesson card.
 */
function ViewLessonPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { course_id } = useParams();
  const course = location?.state?.course || {};
  const lesson = location?.state?.lesson || {};
  const courseId = course?.course_id ?? course_id;

  const [lessonParent, setlessonParent] = useState(lesson);
  const setCanDownload = () => { };
  const setLessonFiles = () => { };
  const setrubricDetails = () => { };
  const setLessonPart = () => { };
  const setIsPlaying = () => { };
  const setParentActiveTab = () => { };

  return (
    <>
      <div className="lesson-andassignment-tab-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="Overview-Lesson-top-header mb-0">
                <div
                  className="Back_button"
                  onClick={() => navigate(`/course/${courseId}/view`, { state: "after submission" })}
                  onKeyDown={(e) => e.key === "Enter" && navigate(`/course/${courseId}/`, { state: "after submission" })}
                  role="button"
                  tabIndex={0}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                  <span>{lessonParent?.name || lesson?.name}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-content">
          <OverviewLesson
            setlessonParent={setlessonParent}
            setCanDownloadParent={setCanDownload}
            setLessonFilesParent={setLessonFiles}
            setrubricDetails={setrubricDetails}
            setLessonPart={setLessonPart}
            setIsPlayingTwo={setIsPlaying}
            setParentActiveTab={setParentActiveTab}
          />
        </div>
      </div>
    </>
  );
}

export default ViewLessonPage;
